.earningsDrawerContentRoot {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.styledSummaryTableWrapper {
  tbody tr:last-child {
    td,
    th {
      border-bottom: none;
    }
  }
}
